import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StormIcon(props: IconProps) {
    return <Icon {...props} iconKey={"storm"}/>
}
